export var addJsonContentTypeHeader = function (headers) {
    if (headers instanceof Headers) {
        headers.set("Content-Type" /* ContentType */, "application/json" /* Json */);
    }
    else if (headers instanceof Array) {
        headers.push(["Content-Type" /* ContentType */, "application/json" /* Json */]);
    }
    else {
        headers["Content-Type" /* ContentType */] = "application/json" /* Json */;
    }
};
